import clsx from 'clsx';

type SignificanceLevel = '<1%' | '<5%' | '<10%' | '>10%' | 'NA';

const STYLES: Record<SignificanceLevel, string> = {
  '<1%': 'bg-red-100 text-red-800 border-red-300',
  '<5%': 'bg-red-50 text-red-700 border-red-200',
  '<10%': 'bg-orange-50 text-orange-700 border-orange-200',
  '>10%': 'bg-panel-2 text-ink-3 border-rule',
  'NA': 'bg-panel-2 text-ink-4 border-rule',
};

export default function SignificanceBadge({
  level,
  className,
}: {
  level: SignificanceLevel;
  className?: string;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border',
        STYLES[level],
        className,
      )}
      title={`Statistical significance: ${level}`}
    >
      {level}
    </span>
  );
}
